module.exports = __webpack_public_path__ + "img/PE.b7074eae.svg";